import { createFileRoute } from "@tanstack/react-router";
import { DocView } from "@/components/views";
import type { RouterAppContext } from "@/utils/custom-types";

export const Route = createFileRoute("/$workspaceId/docs/$channelId")({
	component: RouteComponent,
});

function RouteComponent() {
	const { workspaceId, channelId } = Route.useParams();
	const { session, currentWorkspace } =
		Route.useRouteContext() as RouterAppContext;
	
	return (
		<DocView
			workspaceId={workspaceId}
			channelId={channelId}
			session={session}
			currentWorkspace={currentWorkspace}
		/>
	);
}
